import styled from '@benzinga/themetron';
import React from 'react';
import { StoryObject } from '@benzinga/advanced-news-manager';
import { FeaturedCard } from './FeaturedCard';
import { SectionTitle } from '@benzinga/core-ui';
import { News } from '@benzinga/basic-news-manager';
import { ScrollToElementLink } from './ScrollToElementLink';

interface NewsSectionProps {
  enableScrollTo?: boolean;
  nodes: StoryObject[] | News[];
  link?: string;
  title?: string;
  showCommentsIcon?: boolean;
  enableReadMore?: boolean;
  dataActionPrefix?: string;
}

export const NewsSection: React.FC<NewsSectionProps> = ({
  dataActionPrefix = 'News Section',
  enableScrollTo = false,
  link,
  nodes,
  showCommentsIcon,
  title,
}) => {
  return (
    <NewsSectionWrapper>
      {title && (
        <div className="news-section-header">
          <SectionTitle>{title}</SectionTitle>
          {link ? <a href={link}>See more</a> : null}
        </div>
      )}
      <div className="news-section-container">
        {nodes[0] && (
          <FeaturedCard
            dataAction={`${dataActionPrefix} - Article 1 Click`}
            imageWidth={260}
            node={nodes[0]}
            showCommentsIcon={showCommentsIcon}
            size="compact"
          />
        )}
        {nodes[1] && (
          <FeaturedCard
            dataAction={`${dataActionPrefix} - Article 2 Click`}
            imageWidth={260}
            node={nodes[1]}
            showCommentsIcon={showCommentsIcon}
            size="compact"
          />
        )}
        {nodes[2] && (
          <FeaturedCard
            dataAction={`${dataActionPrefix} - Article 3 Click`}
            imageWidth={260}
            node={nodes[2]}
            showCommentsIcon={showCommentsIcon}
            size="compact"
          />
        )}
        {nodes[3] && (
          <FeaturedCard
            dataAction={`${dataActionPrefix} - Article 4 Click`}
            imageWidth={260}
            node={nodes[3]}
            showCommentsIcon={showCommentsIcon}
            size="compact"
          />
        )}
      </div>
      {enableScrollTo && (
        <div className="flex justify-end pt-2">
          <ScrollToElementLink href="#more-news">Read More...</ScrollToElementLink>
        </div>
      )}
    </NewsSectionWrapper>
  );
};

export const NewsSectionWrapper = styled.div`
  display: block;
  margin: 16px 0;
  .news-section-header {
    align-items: center;
    display: inline-flex;
    justify-content: space-between;
    width: 100%;
    border-bottom: solid 1px ${({ theme }) => theme.colorPalette.neutral500};
    margin: 16px 0;
    padding: 4px 0;
  }
  .news-section-container {
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-template-rows: repeat(1, minmax(0, 1fr));
    @media (max-width: 768px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      grid-template-rows: repeat(2, minmax(0, 1fr));
    }

    .post-title {
      .line-wrapper {
        -webkit-line-clamp: 4;
      }
    }
  }
`;
